module.exports = __webpack_public_path__ + "static/media/developer.cd555bed.svg";